import { Http } from '../../../support';
import Storage from '../../../support/Storage';

class NominaCatalogoManager {

  static __values = {};

  static async boot() {
    let value = await Storage.get('catalogo.nomina');

    const params = {
      name: 'c_nom',
      version: !!value ? value.version : '0'
    }

    let response = {};

    try {
      response = await Http.get('/api/catalogos/grupos', { params });
    } catch (error) {
      console.error(error);
    }

    if (!!response.data && response.data.length > 0) {
      value = {
        'version': response.data[0].version,
        'data': response.data
      };

      await Storage.put('catalogo.nomina', value);
    }

    if (!!value) {
      for (const item of value.data) {
        NominaCatalogoManager.__values[item.name] = item.values;
      }
    } else {
      throw new Error('Los catálogos de Nómina no están disponibles');
    }
  }

  static get(catalog, _default = null) {
    return NominaCatalogoManager.__values[catalog] || _default;
  }

  static all() {
    return NominaCatalogoManager.__values;
  }

}

export default NominaCatalogoManager;